import { useContext } from 'react'
import { Helmet } from 'react-helmet-async'
import PropTypes from 'prop-types'

import { faGlobe } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Columns, DashboardModule, LoadingModule,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import { generateUrls } from '@hooks/useRole'
import useRoles from '@hooks/useRoles'

import ListBlankState from '@components/ListBlankState'
import PageFilterModule from '@components/PageFilterModule'
import PageHeader from '@components/PageHeader'

import RoleListItem from '../RoleListItem'

const buildPageFilterFields = () => {
  const style = {
    marginBottom: 16,
  }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'string',
      label: 'Filter by Title or ID',
    },
  ]
}

const PageContent = (props) => {
  const { pageFilters } = props

  const {
    filteredRoles,
    hasFilteredRoles,
    loading,
  } = useRoles({ filters: pageFilters, performHttpRequests: true })

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      resetFilters,
      updateFilters,
    },
    defaultFilters,
  } = pageContext

  const { rolesIndexUrl } = generateUrls()

  return (
    <>
      <Helmet>
        <title>Roles | Realhub</title>
      </Helmet>

      <PageHeader
        activeTabBarItemKey="roles"
        tabBarItems={[
          {
            href: rolesIndexUrl,
            icon: faGlobe,
            key: 'roles',
            title: 'Roles',
          },
        ]}
        title="Roles"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <LoadingModule loading={loading} times={3} />

            {!loading && !hasFilteredRoles && <ListBlankState />}

            {!loading && hasFilteredRoles && (
              <DashboardModule title="Roles">
                <Box flexDirection="column">
                  {filteredRoles.map(role => (
                    <RoleListItem key={role.id} role={role} />
                  ))}
                </Box>
              </DashboardModule>
            )}
          </Columns.Main>

          <Columns.Sidebar>
            <PageFilterModule
              callbacks={{ resetFilters, updateFilters }}
              defaultFilters={defaultFilters}
              filterFields={buildPageFilterFields()}
              pageFilters={pageFilters}
            />
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

PageContent.propTypes = {
  pageFilters: PropTypes.object.isRequired,
}

export default PageContent
